import {gql} from '@apollo/client';

export default gql`
  mutation mergeCompany($input: MergeCompanyInput!) {
    authed {
      success
    }
    mergeCompany(input: $input) {
      company {
        id
        name
        slug
        url
        description
        createdAt

        image {
          id
          width
          height
          src
          contentType
        }
      }
    }
  }
`;
